// 支払明細一覧の絞り込み条件（本城さん要望 2026-08-24）
//
// 条件は App 側で保持し、一覧画面と個人明細の「前の人／次の人」ナビの両方に同じ判定を適用する。
// 以前は一覧画面のローカル state だったため、個人明細へ移動すると条件が消え、
// 前後ナビも絞り込みを無視した全員リストを辿っていた。

import type { Carrier, Statement } from "../types";

// タブのフィルタキー（status 3種 ＋ 派生の「要確認」）
export type StatementStatusFilter = "" | "draft" | "confirmed" | "hold" | "attention";

export type StatementFilters = {
  query: string;
  carrier: Carrier | "";
  status: StatementStatusFilter;
};

export const EMPTY_FILTERS: StatementFilters = { query: "", carrier: "", status: "" };

export const hasActiveFilters = (f: StatementFilters): boolean =>
  f.query !== "" || f.carrier !== "" || f.status !== "";

// 要確認＝（警告あり or 売上0：単価0・マスター未登録など）かつ 未確定。
// 確定済み＝事務員が中身を見てOKと判断したもの → 要確認から外す。ホーム画面の進捗と同一定義。
export const needsAttention = (s: Statement): boolean =>
  (s.warnings.length > 0 || s.salesTotal <= 0) && s.status !== "confirmed";

export function matchesFilters(s: Statement, f: StatementFilters): boolean {
  if (f.query && !s.driverName.includes(f.query) && !s.driverId.toLowerCase().includes(f.query.toLowerCase())) return false;
  if (f.carrier && !(s.carriers ?? [s.carrier]).includes(f.carrier)) return false;
  if (f.status === "attention") {
    if (!needsAttention(s)) return false;
  } else if (f.status && s.status !== f.status) return false;
  return true;
}

// 一覧と同じ並び（差引支給額の降順）で絞り込み後リストを作る
export function filterAndSortStatements(statements: Statement[], f: StatementFilters): Statement[] {
  return statements.filter((s) => matchesFilters(s, f)).sort((a, b) => b.netTotal - a.netTotal);
}

// 前後ナビの位置表示に添える「何で絞り込んでいるか」の短い説明
export function filterLabel(f: StatementFilters): string {
  const parts: string[] = [];
  if (f.carrier) parts.push(f.carrier === "yamato" ? "ヤマト" : "佐川");
  if (f.status) {
    const m: Record<Exclude<StatementStatusFilter, "">, string> = {
      draft: "未確定",
      confirmed: "確定",
      hold: "保留",
      attention: "要確認",
    };
    parts.push(m[f.status]);
  }
  if (f.query) parts.push(`「${f.query}」`);
  return parts.length > 0 ? parts.join("・") + "で絞り込み中" : "";
}
